// removed by extract-text-webpack-plugin
module.exports = {"hero":"styles__hero___fecYC","title":"styles__title___1-r6i","content":"styles__content___2SRMe","company-tab":"styles__company-tab___1g-rt","staff-tab":"styles__staff-tab___1e3h7","owners":"styles__owners___3sIOa","tabsToggle":"styles__tabsToggle___vW-SJ"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/AboutUs/styles.scss
// module id = 188
// module chunks = 0